"use strict";
const $c351985a5fbff4b0$export$a1fa174c34b29509 = new window.Swiper(".swiper-1", {
    direction: "vertical",
    loop: true,
    pagination: {
        el: ".swiper-pagination-1",
        clickable: true
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    }
});
const $c351985a5fbff4b0$export$c22247038cf73569 = new window.Swiper(".swiper-2", {
    initialSlide: 1,
    slidesPerView: 3,
    centeredSlides: true,
    direction: "horizontal",
    loop: true,
    pagination: {
        el: ".swiper-pagination-2",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: false
    }
});


"use strict";
const $b464e8376c58de0c$var$lat = 40.67396622964864;
const $b464e8376c58de0c$var$lon = -73.96277562292426;
const $b464e8376c58de0c$export$871de8747c9eaa88 = L.map("map").setView([
    $b464e8376c58de0c$var$lat,
    $b464e8376c58de0c$var$lon
], 13);
L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 60
}).addTo($b464e8376c58de0c$export$871de8747c9eaa88);
L.marker([
    $b464e8376c58de0c$var$lat,
    $b464e8376c58de0c$var$lon
]).addTo($b464e8376c58de0c$export$871de8747c9eaa88);
const $b464e8376c58de0c$var$customCssIcon = L.divIcon({
    className: "custom-pin",
    iconSize: [
        106,
        106
    ],
    iconAnchor: [
        15,
        42
    ],
    popupAnchor: [
        0,
        -42
    ]
});
L.marker([
    51.5,
    -0.09
], {
    icon: $b464e8376c58de0c$var$customCssIcon
}).addTo($b464e8376c58de0c$export$871de8747c9eaa88).bindPopup("We are here!").openPopup();
$b464e8376c58de0c$export$871de8747c9eaa88.scrollWheelZoom.disable();
$b464e8376c58de0c$export$871de8747c9eaa88.on("click", function() {
    $b464e8376c58de0c$export$871de8747c9eaa88.scrollWheelZoom.enable();
});
$b464e8376c58de0c$export$871de8747c9eaa88.on("mouseout", function() {
    $b464e8376c58de0c$export$871de8747c9eaa88.scrollWheelZoom.disable();
});


"use strict";
function $d2247bac48b6a171$export$89c2621768820c8b(event) {
    event.preventDefault();
    const nameInputElement = document.getElementById("name");
    const emailInputElement = document.getElementById("email");
    const nameErrorElement = document.getElementById("nameError");
    const emailErrorElement = document.getElementById("emailError");
    const successMessage = document.getElementById("successMessage");
    nameErrorElement.textContent = "";
    emailErrorElement.textContent = "";
    if (nameInputElement.value.trim() === "") nameErrorElement.textContent = "Name is required.";
    else if (nameInputElement.value.length < 2) nameErrorElement.textContent = "Name must be at least 2 characters long.";
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailInputElement.value.trim() === "") emailErrorElement.textContent = "Email is required.";
    else if (!emailPattern.test(emailInputElement.value)) emailErrorElement.textContent = "Please enter a valid email address.";
}


"use strict";
document.getElementById("form").addEventListener("submit", (0, $d2247bac48b6a171$export$89c2621768820c8b));


//# sourceMappingURL=index.1b8dc395.js.map
